<template>
    <div>
        <h2 class="title">留言</h2>
        <Input v-model="value" type="textarea" :rows="12" :placeholder="placeholder" />
        <div class="toolBox">
            <Button class="btn" type="success" @click="submit">提交</Button>
        </div>
        <div>
            <div class="h-600">
                <div  class="c-area">
                    <div  class="ctitle">
                        <!-- 留言卡片开始 -->
                        <div class="ds-post-main" v-for="i in messages">
                            <div class="ds-avatar">
                                <img src="../../../static/img/post1.png">
                            </div>
                            <div class="ds-comment-body">
                                <div class="post-name">{{i.userName}} <span>{{i.createDate | formatTime}}</span></div>
                                <!-- <hr class="post-hr"> -->
                                <div class="post-txt pw">{{i.extension}}</div>
                            </div>
                        </div>
                        <!-- 留言卡片结束 -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: {
            default: '填写信息...'
        },
        messages: {
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            value: ""
        }
    },
    methods: {
        submit() {
            if(this.value == "") {
                this.$Message.info('填写信息不能为空')
            }else {
                this.$emit('submit', this.value)
            }
        },
        reSet() {
            this.value = ""
        }
    }

}
</script>

<style lang="scss" scoped>
    .title{
        border-bottom: 1px solid #dddddd; 
        margin-bottom: 10px;
    }
    .toolBox{
        &::after{
            content: "";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
        }
    }
    .btn{
        margin-top: 10px;
        float: right;
    }
    .msgList{
        list-style: none;
        li{
            width: 100%;
            // height: 80px;
            background: #fafafa;
            margin-bottom: 10px;
            line-height: 40px;
        }
    }
    .apage {
        margin:0 auto;
        text-align:center;
    }
    .ds-post{background:#F5F5F5;}
    .ds-post-main {position:relative;width:100%;margin-bottom: 10px;box-shadow: 0px 6px 6px -6px #5E5E5E; background:#2A90DF ; }
    .ds-avatar {position:absolute; top:15px; width:40px; height:40px; padding:5px; background:#2A90DF ;border-radius:50%;z-index:1;display: flex;justify-content: center;align-items: center;}
    .ds-avatar img{width: 32px;height: 32px;}
    .ds-comment-body {margin-left:20px;padding:10px 10px 10px 30px ;height:auto;background:#F0F8FF ;}
    .post-name{font-size:14px;color:#DE4C1C;text-align:left;margin-left: 10px;border-bottom: 1px dotted #2A90DF;padding-bottom: 3px;}
    .post-name span{font-size: 10px;color:#A9A9A9;margin-left:20px;vertical-align:bottom; }
    .post-txt{font-size:12px;color:#000;text-align:left;padding:10px;height:auto;line-height:1.5em;  word-break:break-all;}
    /* 留言结束 */
</style>



// WEBPACK FOOTER //
// src/components/LeaveMessage/LeaveMessage.vue